// extracted by mini-css-extract-plugin
export default {"zoomModal":"D5-z"};